import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RunningDaysWatermarkComponent } from '@dossier/shared/components/running-days-watermark/running-days-watermark.component';
import { DossierDirectivesModule } from '@dossier/shared/directives/dossier-directives.module';
import { DossierPipesModule } from '@dossier/shared/pipes/dossier-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    DossierPipesModule,
    DossierDirectivesModule
  ],
  declarations: [
    RunningDaysWatermarkComponent
  ],
  exports: [
    RunningDaysWatermarkComponent
  ]
})
export class RunningDaysWatermarkModule {
}
